import { $, $$ } from "@/utilities/helpers";
import { animate, cubicBezier, stagger, frame } from "motion";

export class MobileMenu {
    constructor(element) {
        this.element = element;
        this.toggleElement = this.element.querySelector(".js-mobile-menu-toggle");
        this.popupElement = this.element.querySelector(".js-mobile-menu-popup");
        this.bezier = cubicBezier(0.23, 1, 0.32, 1);
        this.navLabels = $$(".mobile-menu__nav-item__label span");
        this.navThumbnails = $$(".mobile-menu__nav-item__thumbnail img");
        this.navLinks = this.element.querySelectorAll(".mobile-menu__nav-item__link");
        this.init();
    }

    init() {
        this._handleMenuClick();
        this._handleMenuLinkClick();
    }

    _handleMenuClick() {
        this.toggleElement.addEventListener("click", () => {
            this.element.classList.toggle("active");

            if (this.element.classList.contains("active")) {
                this.animateMenuIn();
            } else {
                this.animateMenuOut();
            }
        });
    }

    _handleMenuLinkClick() {
        this.navLinks.forEach((link) => {
            link.addEventListener("click", (event) => {
                event.preventDefault();

                // Remove active class from all links and add to the clicked link
                this.navLinks.forEach((link) => {
                    link.classList.remove("active");
                });
                event.target.classList.add("active");

                // Close the menu and remove the active class
                this.element.classList.remove("active");

                // Animate the menu out
                // Use the animation promise to wait for the animation to finish
                // and then scroll to the target element
                this.animateMenuOut().then(() => {
                    let targetSelector = event.target.getAttribute("href");
                    // only get the hash part of the href
                    const hashIndex = targetSelector.indexOf("#");
                    if (hashIndex !== -1) {
                        targetSelector = targetSelector.substring(hashIndex);
                    }

                    // Get element to scroll to
                    const targetElement = document.querySelector(targetSelector);
                    if (!targetElement) {
                        console.error(`Target element ${target} not found.`);
                        return;
                    }

                    // Scroll to the target element
                    targetElement.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                    });
                });
            });
        });
    }

    animateMenuIn() {
        animate(
            this.popupElement,
            {
                y: ['100%', 0],
                opacity: 1,
                zIndex: 99,
            },
            {
                ease: this.bezier,
                duration: 0.6
            },
        );

        let nav_labels = [];

        this.navLabels.forEach((label, index) => {
            nav_labels.push([
                label,
                { y: ['100%', 0] },
                {
                    ease: this.bezier,
                    duration: 0.1,
                    delay: stagger(0.01 * index),
                }
            ]);
        });

        animate(nav_labels);

        this.navThumbnails.forEach((thumbnail, index) => {
            animate(
                thumbnail,
                { opacity: [0, 0.6] },
                {
                    ease: this.bezier,
                    duration: 0.4,
                }
            );
        });

    }

    animateMenuOut() {
        return animate(
            this.popupElement,
            { y: [0, '-100%'] },
            {
                ease: this.bezier,
                duration: 0.9
            },
        )
    }
}